import React from 'react'
import injectSheet from 'react-jss'
import styles from './sidebar.styles'
import Contributors from './contributors/contributors.container'

const Sidebar = ({ classes }) => {
  return (
    <aside className={classes.container}>
      <Contributors />
    </aside>
  )
}

export default injectSheet(styles)(Sidebar)
